module.exports = __webpack_public_path__ + "static/media/user-shape.e55e905d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/user-shape.svg
// module id = 520
// module chunks = 0